/**
* Verifica se o valor é um índice cadastral válido de IPTU
*
* @param {string} processo
*/
function validarProcesso(processo) {
    processo = processo.padStart(11, '0');
        
    let soma = 0;
    let multiplicador = 2;

    if (+processo === 0) return false;

    const ultimoDigito = parseInt(processo.charAt(processo.length - 1));

    for (let i = processo.length - 2; i >= 0; i--) {
      let digito = +processo[i];
      soma += digito * multiplicador;
      multiplicador = (multiplicador < 9) ? (multiplicador + 1) : 2;
    }

    const resultado = soma % 11;
    const digitoVerificador = (resultado === 1 || resultado === 0) ? 0 : (11 - resultado);

    return digitoVerificador === ultimoDigito;
}

module.exports = {
  validarProcesso,
}    